export const cra = {
  month: "Mois",
  year: "Année",
  totalProduction: "Production totale",
  totalAbsences: "Absences totales",
  status: "Statut",
  createdAt: "Créé le",
  pending: "En attente de validation",
  validated: "Validé",
  title_edit: "Détails du CRA",
  collaborator: "collaborateur",
  actions: {
    view: "Voir",
    validate: "Valider",
  },
  messages: {
    validated: "CRA validé avec succès",
    validate_error: "Erreur lors de la validation du CRA",
  },
  title: "Feuilles de temps",
  column_period: "Période",
  column_status: "Statut",
  status_draft: "Brouillon",
  status_pending_validation: "En attente de validation",
  status_validated: "Validé",
  status_refused: "Refusé",
  status_pending: "En attente",
  loading: "Chargement...",
  header_title: "Suivi des CRA",
};
